/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useDrag } from "react-dnd";
import { SortableItemTypes } from "./sortable-item-types";

/**
 * @param {string} id
 * @param {number} originalIndex
 * @param {() => void} onDrop
 * @param {SwapItems} swap
 */
export function useItemDrag (id, originalIndex, onDrop, swap) {
    const dragOpts = useDrag({
        type: SortableItemTypes.CONTENT,
        item: { id, originalIndex },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
        end (item, monitor) {
            const { id: droppedId, originalIndex } = item;
            const didDrop = monitor.didDrop();

            if (didDrop) {
                onDrop();
            } else {
                // reset to it's original position
                swap(droppedId, originalIndex);
            }
        },
    });

    return dragOpts;
}
